import React, { useEffect, useState } from "react";

import { Button, Offcanvas, Dropdown } from "react-bootstrap";
import { logoutUser } from "../redux/auth/actions";
import ToggleIcon from "../assets/images/icons/list.png";
import TelegramIcon from "../assets/svg/TelegramIcon";
import WhatsappIcon from "../assets/svg/WhatsappIcon";
import numberWithCommas from "../utils/numbersWithComma";
import Profile from "../assets/images/icons/user-profile-wht.png";
import MyBets from "../assets/images/icons/my-bets-wht.png";
import Bonus from "../assets/images/icons/bonus-wht.png";
import Referral from "../assets/images/icons/referral-wht.png";
import Statement from "../assets/images/icons/statement-wht.png";
import SPMGames from "../assets/images/icons/spm-games.png";
import Withdraw from "../assets/images/icons/cash-withdrawal.png";
import Logout from "../assets/images/icons/signout-wht.png";
import GamesSearchModal from "../views/components/GamesSearchModal";
import { getNotifications } from "../redux/app/actions";
import { AiOutlineClose } from "react-icons/ai";
import { VscVerifiedFilled } from "react-icons/vsc";
import ProfileIcon from "../assets/images/icons/man.png";
import Gift from "../assets/images/icons/gift.png";
import DropdownItem from "react-bootstrap/esm/DropdownItem";
import { useDispatch, useSelector } from "react-redux";

import EzugiIcon from "../assets/images/icons/bottom-header/casino-chip.png";
import EvolutionIcon from "../assets/images/icons/bottom-header/playing-card.png";
import VivoIcon from "../assets/images/icons/bottom-header/spades.png";
import SupernowaIcon from "../assets/images/icons/bottom-header/dice.png";
import QtechIcon from "../assets/images/icons/bottom-header/cherry.png";
import XPGIcon from "../assets/images/icons/bottom-header/poker-cards.png";
import SlotsIcon from "../assets/images/icons/bottom-header/diamond.png";
import KingmakerIcon from "../assets/images/icons/bottom-header/crown.png";

const HeaderAfterLogin = () => {
  const { user, wallet } = useSelector((state) => state.auth);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const { appDetails } = useSelector((state) => state.app);
  const [showLeftbarToggle, setShowLeftbarToggle] = useState(false);
  const [websiteNotifications, setWebsiteNotifications] = useState([]);
  const [showNotifications, setShowNotifications] = useState(true);

  useEffect(() => {
    loadNotifications();
    return () => {};
  }, []);

  const loadNotifications = async () => {
    // get notifications
    const notifications = await getNotifications();
    if (notifications && notifications?.data?.data) {
      setShowNotifications(true);
      setWebsiteNotifications(notifications?.data?.data);
    }
  };

  const handleToggleClick = () => {
    const realTimeValue = !showLeftbarToggle;
    if (!document.body.classList.contains("leftbat-opened")) {
      document.body.classList.add("leftbat-opened");
    } else {
      document.body.classList.remove("leftbat-opened");
    }
    setShowLeftbarToggle(realTimeValue);
  };

  return (
    <>
      {(websiteNotifications.length && showNotifications && (
        <div className="marqu">
          <marquee>
            {websiteNotifications.map((notf, idx) => (
              <label style={{ marginRight: "30px" }} key={idx}>
                {notf?.content}
              </label>
            ))}
          </marquee>
          <span onClick={() => setShowNotifications(false)}>
            <AiOutlineClose />
          </span>
        </div>
      )) ||
        null}
      <header className="header aftrlgn">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center">
                <div className="d-flex align-items-center">
                  <div className="leftbar_toggle d-lg-block d-none">
                    <Button
                      variant="primary"
                      onClick={() => handleToggleClick()}
                    >
                      <img loading="lazy" src={ToggleIcon} />
                    </Button>
                  </div>
                  <div className="logo">
                    <a href="/home">
                      <img
                        loading="lazy"
                        src={appDetails?.LOGO_URL}
                        alt="Logo"
                      />
                    </a>
                  </div>
                </div>

                <div className="headerRight">
                  <div className="d-md-block d-none">
                    <GamesSearchModal />
                  </div>

                  <div className="BalanceDropdown">
                    <Dropdown align="end" className="me-2 ">
                      <Dropdown.Toggle variant="success" id="dropdown-basic">
                        Bal: <span>{numberWithCommas(wallet?.cash || 0)}</span>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item href="tel:{user?.mobileno}">
                          <b>{user?.mobileno}</b>
                        </Dropdown.Item>
                        <Dropdown.Item href="#">
                          <h6>Balance</h6>
                          <span>
                            {numberWithCommas(wallet?.balance || 0)}
                          </span>
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="#"
                          // onClick={() => setShowBetModal(true)}
                        >
                          <h6>Cash</h6>
                          <span>{numberWithCommas(wallet?.cash || 0)}</span>
                        </Dropdown.Item>

                        <Dropdown.Item href="/bonus">
                          <h6>Coins</h6>
                          <span>{numberWithCommas(wallet?.coins)}</span>
                        </Dropdown.Item>
                        <Dropdown.Item
                          href="/gatewaylist"
                          className="deposit btn-primary btn"
                        >
                          Deposit
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                    <ul>
                      <li className="">
                        <a href="/gatewaylist" className="deposit">
                          <span className="d-md-block d-none"> Deposit</span>
                          <span className="d-md-none d-block"> +</span>
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="d-md-none">
                    <GamesSearchModal />
                  </div>

                  <ul className="BonuSection">
                    <li>
                      <a href="/promotion">
                        <img loading="lazy" src={Gift} />
                      </a>
                    </li>
                  </ul>

                  <div className="MenuDropdown">
                    <Dropdown align="end" className=" ">
                      <Dropdown.Toggle variant="success" id="dropdown-basic1">
                        <img
                          loading="lazy"
                          src={ProfileIcon}
                          width={35}
                          height={35}
                        />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item href="/profile">
                          <img
                            loading="lazy"
                            src={Profile}
                            alt="profile"
                            width={24}
                            height={24}
                          />
                          <span>Profile</span>
                        </Dropdown.Item>{" "}
                        <Dropdown.Item href="/withdraw">
                          <img
                            loading="lazy"
                            src={Withdraw}
                            alt="profile"
                            width={24}
                            height={24}
                          />
                          <span>Withdraw</span>
                        </Dropdown.Item>
                        <Dropdown.Item href="/mybets">
                          <img
                            loading="lazy"
                            src={MyBets}
                            alt="my bets"
                            width={24}
                            height={24}
                          />
                          <span>My Bets</span>
                        </Dropdown.Item>
                        <Dropdown.Item href="/bonus">
                          <img
                            loading="lazy"
                            src={Bonus}
                            alt="bonus"
                            width={24}
                            height={24}
                          />
                          <span>Bonus</span>
                        </Dropdown.Item>
                        <Dropdown.Item href="/referral">
                          <img
                            loading="lazy"
                            src={Referral}
                            alt="referral"
                            width={24}
                            height={24}
                          />
                          <span>Referral</span>
                        </Dropdown.Item>
                        <Dropdown.Item href="/cashier">
                          <img
                            loading="lazy"
                            src={Statement}
                            alt="account statement"
                            width={24}
                            height={24}
                          />
                          <span>Account Statement</span>
                        </Dropdown.Item>
                        <DropdownItem
                          onClick={() => dispatch(logoutUser(true))}
                        >
                          <img
                            loading="lazy"
                            src={Logout}
                            alt="logout"
                            width={24}
                            height={24}
                          />
                          <span>Sign Out</span>
                        </DropdownItem>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Offcanvas show={show} onHide={() => setShow(false)} placement={"end"}>
          <Offcanvas.Body>
            <ul className="menu-items">
              <li>
                <a href="/profile">
                  <img loading="lazy" src={Profile} alt="profile" />
                  <span>Profile</span>
                </a>
              </li>
              <li>
                <a href="/mybets">
                  <img loading="lazy" src={MyBets} alt="my bets" />
                  <span>My Bets</span>
                </a>
              </li>
              <li>
                <a href="/bonus">
                  <img loading="lazy" src={Bonus} alt="bonus" />
                  <span>Bonus</span>
                </a>
              </li>
              <li>
                <a href="/referral">
                  <img loading="lazy" src={Referral} alt="referral" />

                  <span>Referral</span>
                </a>
              </li>
              <li>
                <a href="/cashier">
                  <img loading="lazy" src={Statement} alt="account statement" />
                  <span>Account Statement</span>
                </a>
              </li>
              <li>
                <a href="/spmgames">
                  <img loading="lazy" src={SPMGames} alt="SPM games" />
                  <span>SPM Games</span>
                </a>
              </li>
              <li>
                <a href="/kyc">
                  <VscVerifiedFilled />
                  <span>KYC</span>
                </a>
              </li>
              <li onClick={() => dispatch(logoutUser(true))}>
                <a href="/">
                  <img loading="lazy" src={Logout} alt="logout" />
                  <span>Sign Out</span>
                </a>
              </li>
            </ul>
            <ul className="social_links">
              <li>
                <a target="_blank" href={`${appDetails?.TELEGRAM}`}>
                  <TelegramIcon />
                </a>
              </li>
              {/* <li>
              <div
                onClick={() =>
                  window.open(https://wa.me/+917888846060, "_blank")
                }
              >
                <WhatsappIcon />
              </div>
            </li> */}
              <li>
                <a
                  className="panel"
                  href={
                    appDetails?.WHATS_APP_URL != ""
                      ? `https://wa.me/${appDetails?.WHATS_APP_URL}`
                      : "#"
                  }
                  target={appDetails?.WHATS_APP_URL != "" ? "_blank" : ""}
                >
                  <WhatsappIcon />
                </a>
              </li>
            </ul>
          </Offcanvas.Body>
        </Offcanvas>
      </header>

      <div className="bottom_heads">
        <ul>
          <li>
            <a href="/casino/ezugi">
              <img src={EzugiIcon} alt="EzugiIcon" />
              Ezugi
            </a>
          </li>
          <li>
            <a href="/casino/evolution">
              <img src={EvolutionIcon} alt="EvolutionIcon" />
              Evolution
            </a>
          </li>
          <li>
            <a href="/casino/vivo">
              <img src={VivoIcon} alt="VivoIcon" />
              Vivo
            </a>
          </li>
          <li>
            <a href="/casino/supernowa">
              <img src={SupernowaIcon} alt="SupernowaIcon" />
              Supernowa
            </a>
          </li>
          <li>
            <a href="/casino/xpg">
              <img src={XPGIcon} alt="XPGIcon" />
              XPG
            </a>
          </li>
          <li>
            <a href="/casino/qtech">
              <img src={QtechIcon} alt="QtechIcon" />
              Qtech
            </a>
          </li>
          <li>
            <a href="/slots">
              <img src={SlotsIcon} alt="SlotsIcon" />
              Slots
            </a>
          </li>
          <li>
            <a href="/kingmaker">
              <img src={KingmakerIcon} alt="KingmakerIcon" />
              Kingmaker
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};

export default HeaderAfterLogin;
